
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 513 342"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#55B2FF","d":"M0 0h513v342H0z"}}),_c('path',{attrs:{"fill":"#F3F3F3","d":"M148.5 298.1h216l-108-254.2z"}}),_c('path',{attrs:{"fill":"#333","d":"M186 272.7l70.5-160.3L327 272.7z"}}),_c('path',{attrs:{"fill":"#FFDA44","d":"M148.5 298.1h216l-108-101.7z"}})])
          )
        }
      }
    